/**
 * Hero Java - Simple Background Image Handler
 * Handles responsive background images and focal points
 */

class HeroJava {
  constructor() {
    this.heroElement = document.querySelector('[data-hero-java]');
    if (!this.heroElement) return;

    this.mediaQuery = window.matchMedia('(max-width: 1024px)');
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    this.init();
  }

  init() {
    this.setupBackgroundImage();
    this.setupFocalPoints();
    this.setupAccessibility();
    this.setupResizeHandler();
  }

  /**
   * Setup Background Image
   */
  setupBackgroundImage() {
    const desktopImage = this.heroElement.dataset.desktopImage;
    const mobileImage = this.heroElement.dataset.mobileImage;
    
    if (desktopImage) {
      this.heroElement.style.backgroundImage = `url(${desktopImage})`;
    }
    
    this.handleMediaChange();
    this.mediaQuery.addEventListener('change', () => this.handleMediaChange());
  }

  handleMediaChange() {
    const isMobile = this.mediaQuery.matches;
    const desktopImage = this.heroElement.dataset.desktopImage;
    const mobileImage = this.heroElement.dataset.mobileImage;
    
    if (isMobile && mobileImage) {
      this.heroElement.style.backgroundImage = `url(${mobileImage})`;
    } else if (desktopImage) {
      this.heroElement.style.backgroundImage = `url(${desktopImage})`;
    }
  }

  /**
   * Setup Focal Points
   */
  setupFocalPoints() {
    const focalX = this.heroElement.dataset.focalX || 50;
    const focalY = this.heroElement.dataset.focalY || 50;
    
    this.heroElement.style.backgroundPosition = `${focalX}% ${focalY}%`;
  }

  /**
   * Setup Accessibility
   */
  setupAccessibility() {
    // Pause any videos if user prefers reduced motion
    if (this.reducedMotion.matches) {
      this.heroElement.style.backgroundAttachment = 'scroll';
    }
    
    this.reducedMotion.addEventListener('change', (e) => {
      if (e.matches) {
        this.heroElement.style.backgroundAttachment = 'scroll';
      } else {
        this.heroElement.style.backgroundAttachment = 'fixed';
      }
    });
  }

  /**
   * Setup Resize Handler
   */
  setupResizeHandler() {
    let resizeTimeout;
    
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        this.handleMediaChange();
      }, 100);
    };
    
    window.addEventListener('resize', handleResize);
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  new HeroJava();
});

// Also initialize if script loads after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new HeroJava();
  });
} else {
  new HeroJava();
}